module.exports = __webpack_public_path__ + "static/media/AlwynNewRounded_Thin.9b8174cf.woff";